import gql from 'graphql-tag';

export default gql`
mutation {
    doNothing @client
  }
`;
